"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenIDConfigurationManager = exports.Cache = void 0;
class Cache {
    constructor(storage, lifetimeMs) {
        this.lifetimeMs = lifetimeMs;
        this.storage = storage;
    }
    add(key, entry) {
        const cacheEntry = {
            cachedAt: (new Date()).toJSON(),
            entry
        };
        this.storage.setItem(key, JSON.stringify(cacheEntry));
    }
    get(key) {
        const cacheEntryCandidate = this.storage.getItem(key);
        if (!cacheEntryCandidate)
            return null;
        const cacheEntry = JSON.parse(cacheEntryCandidate);
        const cachedAt = new Date(cacheEntry.cachedAt);
        const isExpired = (cachedAt.valueOf() + this.lifetimeMs) >= Date.now();
        if (isExpired)
            return null;
        return cacheEntry.entry;
    }
}
exports.Cache = Cache;
class OpenIDConfigurationManager {
    constructor(authority, clientID, cacheStorage) {
        if (!authority.startsWith('http'))
            throw new Error(`OpenIDConfigurationManager authority should start with https://`);
        this.authority = authority;
        this.clientID = clientID;
        this.cache = cacheStorage ? new Cache(cacheStorage, 60000) : undefined;
    }
    fetch() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.authority}/.well-known/openid-configuration?client_id=${this.clientID}`;
            const cacheEntry = (_a = this.cache) === null || _a === void 0 ? void 0 : _a.get(url);
            if (cacheEntry)
                return cacheEntry;
            const response = yield fetch(url);
            const metadata = yield response.json();
            metadata.client_id = this.clientID;
            (_b = this.cache) === null || _b === void 0 ? void 0 : _b.add(url, metadata);
            return metadata;
        });
    }
}
exports.OpenIDConfigurationManager = OpenIDConfigurationManager;
//# sourceMappingURL=OpenIDConfiguration.js.map